import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import ImageTerms, { IMAGE_TERMS_TITLE } from "../../components/common/ImageTerms";
import "./TermsModal.css";

interface TermsModalProps {
  show: boolean;
  onHide: () => void;
  onAccept: () => void;
  imageUrl: string;
}

export default function TermsModal({ show, onHide, onAccept, imageUrl }: TermsModalProps) {
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  useEffect(() => { setAcceptedTerms(false); }, [show, imageUrl]);
  const accept = () => {
    if (!acceptedTerms) return;
    onAccept(); onHide();
  };
  return <Modal show={show} onHide={onHide} size="lg" centered className="terms-modal" aria-labelledby="image-terms-modal-title">
    <Modal.Header closeButton><Modal.Title id="image-terms-modal-title" className="terms-title">{IMAGE_TERMS_TITLE}</Modal.Title></Modal.Header>
    <Modal.Body className="terms-body">
      <ImageTerms />
      <div className="terms-checkbox"><label>
        <input type="checkbox" checked={acceptedTerms} onChange={event => setAcceptedTerms(event.target.checked)} />
        <span>Li e concordo com os termos de uso e responsabilidade sobre as imagens.</span>
      </label></div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide} className="btn-cancel">Cancelar</Button>
      <Button variant="primary" onClick={accept} disabled={!acceptedTerms}>Aceitar</Button>
    </Modal.Footer>
  </Modal>;
}
